import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/form/page-form.vue'),
      // component: () => import('@/views/home/page-home.vue'),
    },
    {
      path: '/print',
      name: 'print',
      component: () => import('@/views/print/page-print.vue'),
    },
  ],
})

export default router
